var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',{staticClass:"item"},_vm._l((_vm.rows),function(item){return _c('tr',{key:item},_vm._l((_vm.cols),function(itemCell){return _c('td',{key:itemCell},[_c('v-skeleton-loader',{staticClass:"text",attrs:{"type":"text"}})],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }